import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'
import logo from '../assests/logo.png'

export default function Header(){
  const [open, setOpen] = useState(false)
  return (
    <header className="site-header">
      <div className="container nav-row">
        <NavLink className="logo" to="/">
          <img src={logo} alt="Travel Trip Journey logo" className="site-logo" />
          <span className="brand">Travel Trip Journey</span>
        </NavLink>
        <button className="nav-toggle" aria-label="Toggle navigation" onClick={()=>setOpen(!open)}>☰</button>
        <nav className={`nav ${open ? 'open' : ''}`} onClick={()=>setOpen(false)}>
          <NavLink to="/">Home</NavLink>
          <NavLink to="/explore">Explore</NavLink>
          <NavLink to="/enquire">Enquire</NavLink>
          <NavLink to="/gallery">Photo Gallery</NavLink>
        </nav>
      </div>
    </header>
  )
}
